import { WorldpayConfig, WorldpayRedirectRequest } from '@checkout/util-models';
import {
  calculateQuotePaymentTotalValue,
  QuoteDetails,
} from '@domgen/dgx-fe-basket';
import { CustomerDetails, PaymentType } from '@domgen/dgx-fe-common';
import {
  FormAdditionalAddress,
  formatFormAddressToCustomerAddress,
} from '@domgen/dgx-fe-forms/address';

export function formatWorldpayPaymentRedirectRequest({
  billingAddress,
  config,
  customerDetails,
  firstSelectedQuote,
}: {
  config: WorldpayConfig;
  billingAddress: FormAdditionalAddress;
  customerDetails?: CustomerDetails;
  firstSelectedQuote?: QuoteDetails;
}): WorldpayRedirectRequest | undefined {
  const amount = calculateQuotePaymentTotalValue(
    firstSelectedQuote,
    PaymentType.Card
  );

  const formattedBillingAddress =
    formatFormAddressToCustomerAddress(billingAddress);

  if (!amount || !customerDetails || !firstSelectedQuote) {
    return undefined;
  }

  return {
    address: customerDetails.address,
    amount,
    billingAddress: formattedBillingAddress,
    companyCode: firstSelectedQuote.companyCode,
    description: config.transactionDescription,
    email: customerDetails.email?.main ?? '',
    name: `${customerDetails.firstName} ${customerDetails.surname}`,
    schemeCode: firstSelectedQuote.schemeCode,
    transactionSource: config.transactionSource,
    transactionType: config.transactionType,
  };
}
